import { createTopLevelAction } from "../../core/make-action";
import TopLevelMethod from "../../core/TopLevelMethod";

const baseCreatePageViewer = createTopLevelAction(
  TopLevelMethod.CREATE_PAGE_VIEWER
);

const baseCreateSnippetViewer = createTopLevelAction(
  TopLevelMethod.CREATE_SNIPPET_VIEWER
);

export function createPageViewer(opts) {
  return function (dispatch) {
    const isSnippet = !!opts.range;
    if (isSnippet) {
      dispatch(baseCreateSnippetViewer(opts));
    } else {
      dispatch(baseCreatePageViewer(opts));
    }
  };
}
